import { ChangeDetectionStrategy, Component, Signal, computed, inject } from '@angular/core';
import { FdDialogShellComponent } from '@shared/componentes/fd-dialog-shell/fd-dialog-shell.component';
import { FD_DIALOG_ANCHO, FD_DIALOG_VARIANTE } from '@shared/componentes/fd-dialog-shell/fd-dialog-shell.constants';
import { InactividadService } from '@core/services/inactividad.service';
import { MENSAJES_MODAL_INACTIVIDAD } from '@core/constants/inactividad.constants';

const SEGUNDOS_POR_MINUTO = 60;
const LONGITUD_PAD = 2;

@Component({
  selector: 'app-modal-sesion-inactiva',
  standalone: true,
  imports: [FdDialogShellComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './modal-sesion-inactiva.component.html'
})
export class ModalSesionInactivaComponent {
  public readonly FD_DIALOG_VARIANTE = FD_DIALOG_VARIANTE;
  public readonly FD_DIALOG_ANCHO = FD_DIALOG_ANCHO;
  public readonly MENSAJES = MENSAJES_MODAL_INACTIVIDAD;
  public readonly visible: Signal<boolean>;
  public readonly tiempoFormateado: Signal<string>;

  private readonly inactividadService = inject(InactividadService);

  constructor() {
    this.visible = this.inactividadService.advertenciaVisible;
    this.tiempoFormateado = computed(() => {
      const total = Math.max(0, this.inactividadService.segundosRestantes());
      const minutos = Math.floor(total / SEGUNDOS_POR_MINUTO);
      const segundos = total % SEGUNDOS_POR_MINUTO;
      return `${this.rellenar(minutos)}:${this.rellenar(segundos)}`;
    });
  }

  public onContinuar(): void {
    this.inactividadService.reiniciar();
  }

  public onCerrarSesion(): void {
    this.inactividadService.cerrarSesionManual();
  }

  private rellenar(valor: number): string {
    return valor.toString().padStart(LONGITUD_PAD, '0');
  }
}
